var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 401",
    d: "M8 4H4C1.79086 4 0 5.79086 0 8V12C0 14.2091 1.79086 16 4 16H8C10.2091 16 12 14.2091 12 12V8C12 5.79086 10.2091 4 8 4Z",
    fill: "url(#paint0_linear_27538_305)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 398",
    d: "M8.5 2H14.5M14.5 2V8M14.5 2L4 11.5",
    stroke: "url(#paint1_linear_27538_305)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27538_305",
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27538_305",
    x1: 9.25,
    y1: 2,
    x2: 9.25,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/explorer.c17380bd6372cac4b61b2db12339abfe.svg";
export { ForwardRef as ReactComponent };